module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "navs-circle active",
    style: ({
      'background-color': _vm.customization.mainColor,
      color: _vm.customization.iconColor,
    }),
    attrs: {
      "id": "navs",
      "data-open": "-",
      "data-close": "+"
    },
    on: {
      "click": _vm.circleMenu
    }
  }, [_c('li', {
    style: ({
      'background-color': _vm.customization.mainColor
    })
  }, [_c('a', {
    style: ({
      color: _vm.customization.iconColor
    }),
    attrs: {
      "href": "garage"
    }
  }, [_c('span', {
    staticClass: "dbc-icon dbc-icon-solid_car"
  })])]), _vm._v(" "), _c('li', {
    style: ({
      'background-color': _vm.customization.mainColor
    })
  }, [_c('a', {
    style: ({
      color: _vm.customization.iconColor
    }),
    attrs: {
      "href": "recommendfriend"
    }
  }, [_c('span', {
    staticClass: "dbc-icon dbc-icon-users-three"
  }), _vm._v(" "), (_vm.referralsCount) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.referralsCount))]) : _vm._e()])]), _vm._v(" "), _c('li', {
    style: ({
      'background-color': _vm.customization.mainColor
    })
  }, [_c('a', {
    style: ({
      color: _vm.customization.iconColor
    }),
    attrs: {
      "href": "contact"
    }
  }, [_c('span', {
    staticClass: "dbc-icon dbc-icon-card-account-phone"
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0a1db6b2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a1db6b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/home-page-components/circle-menu.component.vue
// module id = 734
// module chunks = 0